import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';

const RDTooltip = ({
  tooltipContent,
  children,
  tooltipBgColor,
  tooltipStyles,
  defaultVisible,
  tooltipPlacement,
}) => (
  <Tooltip
    title={tooltipContent}
    color={tooltipBgColor}
    style={tooltipStyles}
    defaultVisible={defaultVisible}
    placement={tooltipPlacement}
  >
    {children}
  </Tooltip>
);

RDTooltip.defaultProps = {
  tooltipBgColor: '#0a7e92',
  tooltipStyles: {},
  tooltipContent: '',
  defaultVisible: false,
  tooltipPlacement: 'top',
};

RDTooltip.propTypes = {
  /** Tooltip content */
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** React Node */
  children: PropTypes.element.isRequired,
  /** Tooltip background color */
  tooltipBgColor: PropTypes.string,
  /** Style of the tooltip */
  tooltipStyles: PropTypes.shape({}),
  /** Whether the floating tooltip card is visible by default */
  defaultVisible: PropTypes.bool,
  /** The position of the tooltip relative to the target */
  tooltipPlacement: PropTypes.oneOf([
    'top',
    'left',
    'right',
    'bottom',
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom',
  ]),
};

export default RDTooltip;
